var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-layout',{attrs:{"layout":['xs12']}},[_c('l-data-table',{attrs:{"headers":_vm.header,"get-data-func":_vm.getAllPassGroupList,"title-text":"全部通行分组列表","search-text":"请输入分组名称","filter-items":_vm.filter,"clickable":""},on:{"click:row":function($event){return _vm.goDetails($event.item)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }